import type { ContractFlow, ContractTemplate } from '@/api/types'

/** 合同 Mock 数据 | 状态流: DRAFT→PENDING_SIGN→SIGNING→SIGNED→EXPIRED→TERMINATED */

export const mockContractTemplates: ContractTemplate[] = [
  {
    id: 'ctpl-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '报名合同模板',
    type: 'ENROLLMENT',
    description: '学员报名标准合同',
    fields: [
      { key: 'studentName', label: '学员姓名', type: 'TEXT', required: true },
      { key: 'idCard', label: '身份证号', type: 'TEXT', required: true },
      { key: 'courseName', label: '课程名称', type: 'TEXT', required: true },
      { key: 'lessonCount', label: '课时数', type: 'NUMBER', required: true },
      { key: 'amount', label: '金额', type: 'NUMBER', required: true },
      { key: 'campus', label: '校区', type: 'TEXT', required: true },
    ],
    status: 'ACTIVE',
    version: 1,
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'ctpl-002',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '办卡合同模板',
    type: 'MEMBERSHIP',
    description: '会员卡办理合同',
    fields: [
      { key: 'studentName', label: '学员姓名', type: 'TEXT', required: true },
      { key: 'cardType', label: '卡类型', type: 'TEXT', required: true },
      { key: 'faceValue', label: '卡面值', type: 'NUMBER', required: true },
      { key: 'price', label: '售价', type: 'NUMBER', required: true },
      { key: 'validDays', label: '有效期', type: 'NUMBER', required: true },
    ],
    status: 'ACTIVE',
    version: 1,
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'ctpl-003',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '课时合同模板',
    type: 'COURSE',
    description: '课时包购买合同',
    fields: [
      { key: 'studentName', label: '学员姓名', type: 'TEXT', required: true },
      { key: 'courseName', label: '课程名称', type: 'TEXT', required: true },
      { key: 'lessonCount', label: '课时数', type: 'NUMBER', required: true },
      { key: 'unitPrice', label: '单价', type: 'NUMBER', required: true },
      { key: 'totalAmount', label: '总金额', type: 'NUMBER', required: true },
    ],
    status: 'ACTIVE',
    version: 1,
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'ctpl-004',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '退费协议模板',
    type: 'REFUND',
    description: '退费标准协议',
    fields: [
      { key: 'studentName', label: '学员姓名', type: 'TEXT', required: true },
      { key: 'originalContractNo', label: '原合同号', type: 'TEXT', required: true },
      { key: 'refundAmount', label: '退费金额', type: 'NUMBER', required: true },
      { key: 'reason', label: '退费原因', type: 'TEXT', required: true },
    ],
    status: 'ACTIVE',
    version: 1,
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'ctpl-005',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '其他合同模板',
    type: 'OTHER',
    description: '通用合同模板',
    fields: [
      { key: 'title', label: '标题', type: 'TEXT', required: true },
      { key: 'content', label: '内容', type: 'TEXT', required: false },
    ],
    status: 'INACTIVE',
    version: 1,
    createdAt: '2025-09-01T10:00:00+08:00',
    updatedAt: '2025-09-01T10:00:00+08:00',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
]

// ===== 合同列表 =====

const now = new Date().toISOString()

export const mockContractFlows: ContractFlow[] = [
  {
    id: 'cf-001',
    brandId: 'b-001',
    campusId: 'c-001',
    flowName: '赵小明-篮球班报名合同',
    flowType: 'ENROLLMENT',
    description: '篮球班季度培训',
    customerId: 'cu-001',
    customerName: '赵小明',
    customerPhone: '13800001111',
    amountMinor: 450000,
    currency: 'CNY',
    templateId: 'ctpl-001',
    approvers: [
      { type: 'ORGANIZATION', name: '总部', phone: '010-12345678', organizationName: '通用SaaS', status: 'SIGNED', signedAt: '2025-10-05T15:00:00+08:00' },
      { type: 'PERSONAL', name: '赵小明', phone: '13800001111', status: 'SIGNED', signedAt: '2025-10-05T15:00:00+08:00' },
    ],
    status: 'SIGNED',
    deadline: '2025-10-10T23:59:59+08:00',
    signedAt: '2025-10-05T15:00:00+08:00',
    entitlementId: 'ea-001',
    createdAt: '2025-10-04T10:00:00+08:00',
    updatedAt: '2025-10-05T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'cf-002',
    brandId: 'b-001',
    campusId: 'c-002',
    flowName: '李东-足球班报名合同',
    flowType: 'ENROLLMENT',
    description: '足球班半年培训',
    customerId: 'cu-003',
    customerName: '李东',
    customerPhone: '13800003333',
    amountMinor: 880000,
    currency: 'CNY',
    templateId: 'ctpl-001',
    approvers: [
      { type: 'ORGANIZATION', name: '朝阳校区', phone: '010-87654321', organizationName: '通用SaaS', status: 'SIGNED', signedAt: '2025-09-10T09:00:00+08:00' },
      { type: 'PERSONAL', name: '李东', phone: '13800003333', status: 'SIGNED', signedAt: '2025-09-10T09:00:00+08:00' },
    ],
    status: 'SIGNED',
    deadline: '2025-09-15T23:59:59+08:00',
    signedAt: '2025-09-10T09:00:00+08:00',
    entitlementId: 'ea-002',
    createdAt: '2025-09-09T14:00:00+08:00',
    updatedAt: '2025-09-10T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'cf-003',
    brandId: 'b-001',
    campusId: 'c-003',
    flowName: '刘洋-私教课合同',
    flowType: 'COURSE',
    description: '一对一私教课时包',
    customerId: 'cu-005',
    customerName: '刘洋',
    customerPhone: '13800005555',
    amountMinor: 1200000,
    currency: 'CNY',
    templateId: 'ctpl-003',
    approvers: [
      { type: 'ORGANIZATION', name: '海淀校区', phone: '010-11112222', organizationName: '通用SaaS', status: 'PENDING' },
      { type: 'PERSONAL', name: '刘洋', phone: '13800005555', status: 'PENDING' },
    ],
    status: 'SIGNING',
    deadline: '2025-10-30T23:59:59+08:00',
    signedAt: null,
    createdAt: '2025-10-22T11:00:00+08:00',
    updatedAt: '2025-10-23T09:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cf-004',
    brandId: 'b-001',
    campusId: 'c-001',
    flowName: '蒋红-年度会员卡合同',
    flowType: 'MEMBERSHIP',
    description: '年度会员服务',
    customerId: 'cu-002',
    customerName: '蒋红',
    customerPhone: '13800002222',
    amountMinor: 3600000,
    currency: 'CNY',
    templateId: 'ctpl-002',
    approvers: [
      { type: 'ORGANIZATION', name: '总部', phone: '010-12345678', organizationName: '通用SaaS', status: 'PENDING' },
      { type: 'PERSONAL', name: '蒋红', phone: '13800002222', status: 'PENDING' },
    ],
    status: 'PENDING_SIGN',
    deadline: '2025-11-01T23:59:59+08:00',
    signedAt: null,
    createdAt: '2025-10-23T08:00:00+08:00',
    updatedAt: '2025-10-23T08:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cf-005',
    brandId: 'b-001',
    campusId: 'c-002',
    flowName: '张玲-游泳班报名合同',
    flowType: 'ENROLLMENT',
    description: '游泳班季度培训',
    customerId: 'cu-004',
    customerName: '张玲',
    customerPhone: '13800004444',
    amountMinor: 360000,
    currency: 'CNY',
    templateId: 'ctpl-001',
    approvers: [
      { type: 'ORGANIZATION', name: '朝阳校区', phone: '010-87654321', organizationName: '通用SaaS', status: 'SIGNED', signedAt: '2025-06-20T10:00:00+08:00' },
      { type: 'PERSONAL', name: '张玲', phone: '13800004444', status: 'SIGNED', signedAt: '2025-06-20T10:00:00+08:00' },
    ],
    status: 'EXPIRED',
    deadline: '2025-09-20T23:59:59+08:00',
    signedAt: '2025-06-20T10:00:00+08:00',
    createdAt: '2025-06-18T15:00:00+08:00',
    updatedAt: '2025-09-21T00:00:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'system',
  },
  {
    id: 'cf-006',
    brandId: 'b-001',
    campusId: 'c-003',
    flowName: '陈静-退费协议',
    flowType: 'REFUND',
    description: '体能课退费',
    customerId: 'cu-006',
    customerName: '陈静',
    customerPhone: '13800006666',
    amountMinor: 300000,
    currency: 'CNY',
    templateId: 'ctpl-004',
    approvers: [
      { type: 'ORGANIZATION', name: '海淀校区', phone: '010-11112222', organizationName: '通用SaaS', status: 'REJECTED', signedAt: null },
      { type: 'PERSONAL', name: '陈静', phone: '13800006666', status: 'PENDING' },
    ],
    status: 'DRAFT',
    deadline: '2025-10-15T23:59:59+08:00',
    signedAt: null,
    createdAt: '2025-09-02T09:00:00+08:00',
    updatedAt: '2025-09-03T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'cf-007',
    brandId: 'b-001',
    campusId: 'c-001',
    flowName: '杨光-篮球班报名合同',
    flowType: 'ENROLLMENT',
    description: '篮球班半年培训',
    customerId: 'cu-007',
    customerName: '杨光',
    customerPhone: '13800007777',
    amountMinor: 880000,
    currency: 'CNY',
    templateId: 'ctpl-001',
    approvers: [
      { type: 'ORGANIZATION', name: '总部', phone: '010-12345678', organizationName: '通用SaaS', status: 'PENDING' },
      { type: 'PERSONAL', name: '杨光', phone: '13800007777', status: 'PENDING' },
    ],
    status: 'DRAFT',
    deadline: null,
    signedAt: null,
    createdAt: now,
    updatedAt: now,
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'cf-008',
    brandId: 'b-001',
    campusId: 'c-002',
    flowName: '黄磊-私教课合同',
    flowType: 'COURSE',
    description: '私教课10次包',
    customerId: 'cu-008',
    customerName: '黄磊',
    customerPhone: '13800008888',
    amountMinor: 660000,
    currency: 'CNY',
    templateId: 'ctpl-003',
    approvers: [
      { type: 'ORGANIZATION', name: '朝阳校区', phone: '010-87654321', organizationName: '通用SaaS', status: 'PENDING' },
      { type: 'PERSONAL', name: '黄磊', phone: '13800008888', status: 'PENDING' },
    ],
    status: 'PENDING_SIGN',
    deadline: '2025-11-10T23:59:59+08:00',
    signedAt: null,
    entitlementId: 'ea-006',
    createdAt: '2025-10-19T16:00:00+08:00',
    updatedAt: '2025-10-19T16:30:00+08:00',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
]

// 保留旧数据向后兼容
export { mockContractFlows as mockContracts }